import styled from 'styled-components';

const InnerWrapper = styled.div`
   margin: 0 auto;
   max-width: 700px;
`;

export { InnerWrapper };
